import { Component, OnInit, Injector } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { ModalBaseComponent } from '../modal-base-component';

@Component({
  selector: 'app-update-connectivity-parameters-modal',
  templateUrl: './update-connectivity-parameters-modal.component.html',
  styleUrls: ['./update-connectivity-parameters-modal.component.css']
})
export class UpdateConnectivityParametersModalComponent extends ModalBaseComponent{

  constructor(inject: Injector, 
    private _bsModalRef: BsModalRef) {
    super(inject);
  }

  //call this whenever you want to close modal
  public closeModal(): void {
    this._bsModalRef.hide();
}

}



// WEBPACK FOOTER //
// ./src/app/achelos-iot/modals/update-connectivity-parameters/update-connectivity-parameters-modal.component.ts